const DEFAULT_SITE_NAME = 'Race Next Step';
const DEFAULT_TITLE = 'Race Next Step | College Guidance, Student Blogs and Career Learning';
const DEFAULT_DESCRIPTION = 'Explore colleges, student blogs, and career learning resources on Race Next Step.';
const DEFAULT_OG_IMAGE = '/favicon.png';

function ensureHeadTag(selector, creator) {
  let tag = document.head.querySelector(selector);

  if (!tag) {
    tag = creator();
    document.head.appendChild(tag);
  }

  return tag;
}

function upsertMetaByName(name, content) {
  const tag = ensureHeadTag(`meta[name="${name}"]`, () => {
    const element = document.createElement('meta');
    element.setAttribute('name', name);
    return element;
  });

  tag.setAttribute('content', content);
}

function upsertMetaByProperty(property, content) {
  const tag = ensureHeadTag(`meta[property="${property}"]`, () => {
    const element = document.createElement('meta');
    element.setAttribute('property', property);
    return element;
  });

  tag.setAttribute('content', content);
}

function upsertCanonical(url) {
  const tag = ensureHeadTag('link[rel="canonical"]', () => {
    const element = document.createElement('link');
    element.setAttribute('rel', 'canonical');
    return element;
  });

  tag.setAttribute('href', url);
}

function normalizeUrl(url = '') {
  if (!url) {
    return window.location.href;
  }

  if (/^https?:\/\//i.test(url)) {
    return url;
  }

  return new URL(url, window.location.origin).toString();
}

export function applySeo({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  canonicalUrl = '',
  ogType = 'website',
  ogImage = DEFAULT_OG_IMAGE,
  twitterCard = 'summary_large_image'
} = {}) {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return;
  }

  const normalizedCanonicalUrl = normalizeUrl(canonicalUrl || window.location.pathname);
  const normalizedOgImage = normalizeUrl(ogImage || DEFAULT_OG_IMAGE);

  document.title = title;

  upsertMetaByName('description', description);
  upsertMetaByName('robots', 'index,follow');
  upsertMetaByProperty('og:site_name', DEFAULT_SITE_NAME);
  upsertMetaByProperty('og:title', title);
  upsertMetaByProperty('og:description', description);
  upsertMetaByProperty('og:url', normalizedCanonicalUrl);
  upsertMetaByProperty('og:type', ogType);
  upsertMetaByProperty('og:image', normalizedOgImage);
  upsertMetaByName('twitter:card', twitterCard);
  upsertMetaByName('twitter:title', title);
  upsertMetaByName('twitter:description', description);
  upsertMetaByName('twitter:image', normalizedOgImage);
  upsertCanonical(normalizedCanonicalUrl);
}

export function buildAbsoluteUrl(path = '/') {
  if (typeof window === 'undefined') {
    return path;
  }

  return normalizeUrl(path);
}

export function getDefaultSeo() {
  return {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
    ogImage: DEFAULT_OG_IMAGE
  };
}
